import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, propTypes, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';
import { findDOMNode } from 'react-dom';
import { Form, Icon, Grid, Accordion } from 'semantic-ui-react';

import { ItemGridWithCart, DatePickerCustomButton } from 'Components';
import { CREATE_EDIT_RECEIPT_INVENTORY_FORM_NAME } from 'Common/FormEnum';
import {
  DatePickerField,
  InputField,
  SelectField,
} from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import {
  CreateEditReceiptInventoryEnum as FieldEnum,
  ItemEnum,
} from 'Common/FieldEnum';
import {
  CreateEditReceiptInventoryEnum as StatusEnum,
  OrdertypeEnum,
} from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { createKeyEventListener } from 'Common/GeneralHelper';

class CreateEditReceiptFormContainer extends Component {
  static propTypes = {
    ...propTypes,
    ...ItemGridWithCart.propTypes,

    isNewEdit: PropTypes.oneOf([StatusEnum.NEW, StatusEnum.EDIT]).isRequired,
    receiptType: PropTypes.oneOf(Object.values(OrdertypeEnum)),
    receiptDetails: PropTypes.object,
    onSiteAndReceiptDateChange: PropTypes.func.isRequired,
    vendorData: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    IsNewEdit: StatusEnum.NEW,
    receiptDetails: {},
  };

  state = {
    accordionActive: true,
  };

  toggleAccordion = () => {
    const { accordionActive: oldActive } = this.state;
    const accordionActive = !oldActive;
    this.setState({ accordionActive });
  };

  onOrderItemsChange = (orderItem) => {
    const { change } = this.props;
    const itemCode = orderItem[ItemEnum.ItemCode];

    const newOrderItem = { _added: Date.now(), ...orderItem };

    change(`${FieldEnum.POItemDetails}['${itemCode}']`, newOrderItem);
  };

  onOrderItemRemove = (orderItem) => {
    const { orderItems, change } = this.props;

    const itemCode = orderItem[ItemEnum.ItemCode];
    const { [itemCode]: oldOrderItem, ...newOrderItems } = orderItems;

    change(FieldEnum.POItemDetails, newOrderItems);
  };

  handleCommentsTab = () => {
    const node = findDOMNode(this);
    const input = node.querySelector('.itemgrid-search-input > input');

    if (input) {
      input.focus();
      return true;
    }

    return false;
  };

  render() {
    const {
      isNewEdit,
      receiptType,
      receiptDetails,
      onSiteAndReceiptDateChange,
      vendorData,
      disabled,
      loading,
      ...itemGridWithCartProps
    } = this.props;

    const { accordionActive } = this.state;

    const isEdit = isNewEdit === StatusEnum.EDIT;
    const hasOrder = Boolean(
      receiptDetails && receiptDetails[FieldEnum.POWONum]
    );
    const orderNumberLabel = `${
      receiptType === OrdertypeEnum.PO
        ? 'PO'
        : receiptType === OrdertypeEnum.WO
        ? 'WO'
        : 'KO'
    } #`;

    return (
      <Form>
        <Accordion fluid styled style={{ marginBottom: '2rem' }}>
          <Accordion.Title
            active={accordionActive}
            onClick={this.toggleAccordion}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Options</span>
          </Accordion.Title>
          <Accordion.Content active={accordionActive}>
            <Grid className="remove-spacing">
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    name={FieldEnum.ReceiptId}
                    component={InputField}
                    type="text"
                    maxLength={50}
                    label="Receipt #"
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    label="Receipt Date"
                    dateFormat={DATE_FORMAT_FOR_UI}
                    name={FieldEnum.ReceiptDt}
                    dropdownMode="select"
                    customInput={
                      <DatePickerCustomButton
                        fluid
                        isDisabled={disabled || loading}
                      />
                    }
                    onChange={(e, newValue, oldValue, field) =>
                      onSiteAndReceiptDateChange(newValue, oldValue, field)
                    }
                    fluid
                    style={{ maxWidth: '188px' }}
                  />
                </Grid.Column>
                <Grid.Column>
                  <SiteComponent
                    name={FieldEnum.SiteId}
                    isForm={true}
                    label="Site"
                    isAllRequired={false}
                    showAllActiveSites={true}
                    onChange={(newValue, oldValue, field) =>
                      onSiteAndReceiptDateChange(newValue, oldValue, field)
                    }
                    disabled={disabled || loading || hasOrder}
                    fluid
                  />
                </Grid.Column>
                <Grid.Column>
                  {/* use vendor ID normally or vendor name for orders */}
                  {isEdit && hasOrder ? (
                    <Field
                      name={FieldEnum.VendorName}
                      component={InputField}
                      type="text"
                      options={vendorData}
                      label="Distributor"
                      disabled={true}
                    />
                  ) : (
                    <Field
                      name={FieldEnum.VendorId}
                      component={SelectField}
                      type="text"
                      options={vendorData}
                      label="Distributor"
                      disabled={disabled || loading}
                      fluid
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Field
                    name={FieldEnum.Invoice}
                    component={InputField}
                    maxLength={50}
                    label="Invoice #"
                    disabled={disabled || loading}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    name={FieldEnum.Comments}
                    component={InputField}
                    maxLength={50}
                    label="Comments"
                    onKeyDown={createKeyEventListener({
                      onTab: this.handleCommentsTab,
                    })}
                    disabled={disabled || loading}
                  />
                </Grid.Column>
                {isEdit && hasOrder && (
                  <React.Fragment>
                    <Grid.Column width={2}>
                      <Field
                        name={FieldEnum.POWONum}
                        component={InputField}
                        type="text"
                        maxLength={50}
                        label={orderNumberLabel}
                        disabled={true}
                      />
                    </Grid.Column>
                    <Grid.Column width={2}>
                      <Field
                        name={FieldEnum.OrderId}
                        component={InputField}
                        type="text"
                        label="Order #"
                        disabled={true}
                      />
                    </Grid.Column>
                    <Grid.Column width={4}>
                      <Field
                        name={FieldEnum.OrderDT}
                        component={DatePickerField}
                        label="Order Date"
                        dateFormat={DATE_FORMAT_FOR_UI}
                        minDate={moment()}
                        type="text"
                        dropdownMode="select"
                        customInput={
                          <DatePickerCustomButton fluid isDisabled={true} />
                        }
                        fluid
                        style={{ maxWidth: '188px' }}
                      />
                    </Grid.Column>
                  </React.Fragment>
                )}
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>

        <ItemGridWithCart
          disabled={disabled}
          loading={loading}
          onOrderItemsChange={this.onOrderItemsChange}
          onOrderItemRemove={this.onOrderItemRemove}
          {...itemGridWithCartProps}
        />
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};

  //vendor id and invoice are required
  if (
    !parseInt(values[FieldEnum.VendorId], 10) &&
    !values[FieldEnum.VendorName]
  ) {
    errors[FieldEnum.VendorId] = 'Distributor is required';
  }

  if (!values[FieldEnum.Invoice]) {
    errors[FieldEnum.Invoice] = 'Invoice is required';
  }

  //all items in order must have a quantity set
  const orderItems = values[FieldEnum.POItemDetails];

  for (let itemCode in orderItems) {
    if (orderItems.hasOwnProperty(itemCode)) {
      const {
        [ItemEnum.PriQty]: priQty,
        [ItemEnum.SecQty]: secQty,
      } = orderItems[itemCode];

      if (!parseInt(priQty, 10) && !parseInt(secQty, 10)) {
        errors[FieldEnum.POItemDetails] =
          'All items in order must have a purchase quantity or pack quantity';
      }
    }
  }

  return errors;
};

const CreateEditReceiptFormForm = reduxForm({
  form: CREATE_EDIT_RECEIPT_INVENTORY_FORM_NAME,
  validate,
  enableReinitialize: true,
})(CreateEditReceiptFormContainer);

const mapStateToProps = (state) => {
  const selector = formValueSelector(CREATE_EDIT_RECEIPT_INVENTORY_FORM_NAME);

  return {
    //https://github.com/redux-form/redux-form/issues/2253
    //https://github.com/redux-form/redux-form/issues/4344
    orderItems: selector(state, [FieldEnum.POItemDetails]) || {},
  };
};

export const CreateEditReceiptForm = connect(
  mapStateToProps,
  null
)(CreateEditReceiptFormForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/components/createEditReceipt/CreateEditReceiptForm.js